import React from 'react';
import styled from 'styled-components';
import About from './About';

const Content = styled.div`
	background : ${props => props.theme.gading};
	width: 100%;
	margin-top: 20px;
	min-height: 250px;
`;

const ContentInner = styled.div`
	width: 80%;
	margin: 0 auto;
	max-width: 800px;
	padding: 20px 0;
`;

const P = styled.p`
	margin: 50px 0 10px 0;
`;

const Footer = () => {
	return(
		<Content>
			<ContentInner>
				<About />
				<p>Ilustrasi oleh <a href='https://www.freepik.com/vectors/people' target="_blank" rel="noopener noreferrer">People vector created by pch.vector - www.freepik.com</a></p>
				<p>Desain terinspirasi dari <a href='https://dribbble.com/shots/14242743-Landing-Page-Design-Greener' target="_blank" rel="noopener noreferrer">Landing Page Design: Greener</a></p>
				<P>Dibuat oleh ulie luissa</P>
			</ContentInner>
		</Content>
	);
}

export default Footer;